<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="设备信息管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="120px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="设备编号：" prop="deviceNickCode">
                        <el-input v-model="form.deviceNickCode" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.deviceNickCode}}
                        </span>
                    </el-form-item>
                    <el-form-item label="设备描述：" prop="deviceName">
                        <el-input v-model="form.deviceName" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.deviceName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="设备类型：" prop="deviceType">
                        <el-select v-model="form.deviceType" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option label="灯箱":value="1"></el-option>
                            <el-option label="电子媒体":value="2"></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.deviceType}}
                        </span>
                    </el-form-item>
                    <!--<el-form-item label="经度：" prop="deviceLon">
                        <el-input v-model="form.deviceLon" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.deviceLon}}
                        </span>
                    </el-form-item>
                    <el-form-item label="纬度：" prop="deviceLat">
                        <el-input v-model="form.deviceLat" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.deviceLat}}
                        </span>
                    </el-form-item>-->
                    <el-form-item label="所属站点：" prop="siteId">
                        <el-select v-model="form.siteId" @change="changeSiteId" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="所在媒体编号：" prop="lightBoxId">
                        <el-select v-model="form.lightBoxId" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option v-for="item in lightBoxCodeData" :key="item.lightBoxId" :label="item.lightBoxCode" :value="item.lightBoxId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="0" :disabled="isView">未使用</el-radio>
                            <el-radio :label="1" :disabled="isView">使用</el-radio>
                            <el-radio :label="2" :disabled="isView">维修</el-radio>
                            <el-radio :label="3" :disabled="isView">损坏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'device_Detail',
    data() {
        var validatedeviceNickCode = (rule, value, callback) => {
            if (this.isEdit == true) {
                if (value == '') {
                    callback(new Error('设备编号不能为空'));
                } else if (this.form.deviceNickCode == this.editdeviceNickCode) {
                    callback();
                } else {
                    var Vthis = this;
                    this.$hrraxios.get(this.$api.device.checkcode + "/" + this.form.deviceNickCode)
                        .then((response) => {
                            var mydata = response.data;
                            if (mydata.Success == true) {
                                if (mydata.Data == true) {
                                    callback(new Error('设备编号已经存在'));
                                } else {
                                    callback();
                                }

                            } else {
                                Vthis.$message({ message: redata.prompt, type: "error" });
                                callback();
                            }
                        })
                }
            } else {
                if (value == '') {
                    callback(new Error('设备编号不能为空'));
                } else {
                    var Vthis = this;
                    this.$hrraxios.get(this.$api.device.checkcode + "/" + this.form.deviceNickCode)
                        .then((response) => {
                            var mydata = response.data;
                            if (mydata.Success == true) {
                                if (mydata.Data == true) {
                                    callback(new Error('设备编号已经存在'));
                                } else {
                                    callback();
                                }

                            } else {
                                Vthis.$message({ message: redata.prompt, type: "error" });
                                callback();
                            }
                        })
                }
            }
        };
        return {
            form: {
                deviceId: 0,
                lightBoxId: "",
                siteId: "",
                deviceNickCode: "",
                deviceName: "",
                deviceType:"",
                //deviceLon: "",
                //deviceLat: "",
                status: 1,
            },
            rules: {
                deviceNickCode: [{ required: true, validator: validatedeviceNickCode, trigger: 'blur' }],
                deviceName: [{ required: true, message: '请输入媒体名字', trigger: 'blur' }],
                //deviceLat: [{ required: true, message: '请输入纬度', trigger: 'blur' }],
                //deviceLon: [{ required: true, message: '请输入经度', trigger: 'blur' }],
                siteId: [{ required: true, message: '请输入所属地铁站', trigger: 'change' }],
                lightBoxId: [{ required: true, message: '请输入所在媒体编号', trigger: 'change' }],
                deviceType: [{ required: true, message: '请输入设备类型', trigger: 'change' }],
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
            siteidData: [],
            lightBoxCodeData: [],
            adLightBoxDefault: "",
            editdeviceNickCode: "",
            isFormLightbox: false,
            returnPath: "",
            //AllOrgListData:[]
        }
    },
    methods: {
        changeSiteId(val) {
            this.adLightBoxDefault = val
            this.form.lightBoxId = ""
            this.lightBoxData();
        },
        lightBoxData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.getNoDevice + "/" + this.adLightBoxDefault)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.lightBoxCodeData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.isAdd ? this.$api.device.addDevice : this.$api.device.addDevice + "/" + this.form.deviceId;
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: Vuethis.returnPath });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
             this.$router.go(-1);
            //this.$router.push({ path: this.returnPath });
        },
        getSiteID(lightboxid){
            var Vuethis = this;
            this.$hrraxios.get(this.$api.lightbox.getSiteIdByLightBoxId+"/"+lightboxid)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.form.siteId = data.Data.siteId;
                        Vuethis.adLightBoxDefault=data.Data.siteId;
                        Vuethis.lightBoxData();
                    } else {
                        Vuethis.$message({ message: data.Prompt, type: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "设备信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.editdeviceNickCode = row.deviceNickCode;
                if (row.siteId != "" && row.siteId !=null) {
                    this.adLightBoxDefault = row.siteId;
                    
                    this.lightBoxData();
                }
                this.isEdit = true;
                if(this.$route.params.lightboxid){
                    this.form.lightBoxId=parseInt(this.$route.params.lightboxid);
                    this.getSiteID(this.$route.params.lightboxid);
                }
            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var myVuethis = this;
            //所属地铁站
            this.$hrraxios.get(this.$api.site.downlist)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.siteidData = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.returnPath = from.path;
        })
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        if (this.$route.params.isLightbox) {
            this.isFormLightbox = this.$route.params.isLightbox;
        }
        this.initData();
    }
};
</script>
<style>
.el-form-module {
    width: 500px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
</style>